/* eslint-disable */
const iDateFormatter = {
    el: $('.I-js-date-formatter'),

    init: function () {
        this.bindEvents();
        this.placeholder = this.el.attr('placeholder');
        this.datePlaceholder = this.el.data('placeholder-date');
    },

    bindEvents: function () {
        this.el.on('input', function () {
            iDateFormatter.validDate($(this).val());
        });

        this.el.on('focus', function () {
            $(this).attr('placeholder', iDateFormatter.datePlaceholder);
        });

        this.el.on('focusout', function () {
            $(this).attr('placeholder', iDateFormatter.placeholder);
        });
    },

    validDate: function (val) {
        if (this.dateIsValid(val)) {
            this.handleDateIsValid();
        } else {
            this.handleDateIsNotValid();
        }
    },

    handleDateIsValid: function () {
        iDateFormatter.el.removeClass('error');
    },

    handleDateIsNotValid: function () {
        iDateFormatter.el.addClass('error');
    },

    isNumeric: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    dateIsValid: function (val) {
        var date = val.split(".");
        var day = date[0],
            month = date[1],
            year = date[2];

        if (val !== '' && this.isNumeric(day) && this.isNumeric(month) && this.isNumeric(year)) {
            var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
            day = parseInt(date[0]);
            month = parseInt(date[1]);
            year = parseInt(date[2]);

            // Adjust for leap years
            if(year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
                monthLength[1] = 29;

            var errors = [];

            if (!((String(year).length === 4) && (year > 1900 ))) {
                errors.push("year");
            }

            if (!(month > 0 && month < 13)) {
                errors.push("month");
            }

            if (day < 0 || day > monthLength[month - 1]) {
                errors.push("day");
            }

            return errors.length === 0;
        } else {
            return false;
        }
    }
};

export default iDateFormatter;